
import animatedArrowWithText from "../common/animated-arrow-with-text.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import OrderDurationGraph from "../common/order-duration-graph.vue";
import NoDataLabel from "../common/no-data-label.vue";
export default {
  components: { animatedArrowWithText, OrderDurationGraph, NoDataLabel },
  data() {
    return {
      stageTimes: [
        "Avg. acceptance time",
        "Avg. preparation time",
        "Avg. pickedup time",
        "Avg. delivery time"
      ]
    };
  },
  computed: {
    ...mapState("report", ["orderDuration", "orderDurationLoading"])
  },
  mounted() {
    this.fetchOrderStages();
  },
  methods: {
    ...mapActions("report", ["getOrderDuration"]),
    async fetchOrderStages(backgroundLoad = true) {
      await this.getOrderDuration({
        backgroundLoad
      });
    }
  }
};
